import 'svelte/internal/disclose-version';

App[$.FILENAME] = 'client/App.svelte';

import * as $ from 'svelte/internal/client';
import Bubble from "./lib/Bubble.svelte";
import Calendar from "./lib/Calendar.svelte";
import Caption from "./lib/Caption.svelte";
import logo from "./assets/logo.png";

var root = $.add_locations($.from_html(`<span> </span>`), App[$.FILENAME], [[94, 178]]);

var root_1 = $.add_locations(
	$.from_html(
		`
        <a><!></a>
      `,
		1
	),
	App[$.FILENAME],
	[[94, 8]]
);

var root_2 = $.add_locations($.from_html(`<video playsinline="" preload="auto" class="absolute inset-0 h-full w-full object-cover"></video>`, 2), App[$.FILENAME], [[105, 22]]);

var root_3 = $.add_locations(
	$.from_html(
		`
      <p class="font-comic text-3xl leading-none"> </p>
      <p class="mt-1 text-sm font-bold"> <br/> </p>
      <span class="mt-3 inline-block rounded-full border-[3px] border-ink bg-gold px-5 py-1 font-comic text-xl tracking-wide shadow-[3px_3px_0_#17150f]">Réserver</span>
    `,
		1
	),
	App[$.FILENAME],
	[[120, 6], [121, 6, [[121, 52]]], [122, 6]]
);

var root_4 = $.add_locations(
	$.from_html(
		`
        <p class="font-comic text-3xl leading-none tracking-wide text-orange [text-shadow:2px_2px_0_#17150f]"> </p>
        <p class="mt-1"> </p>
      `,
		1
	),
	App[$.FILENAME],
	[[133, 8], [134, 8]]
);

var root_5 = $.add_locations(
	$.from_html(
		`
    <div class="absolute flex items-center justify-center">
      <!>
    </div>
  `,
		1
	),
	App[$.FILENAME],
	[[131, 4]]
);

var root_6 = $.add_locations(
	$.from_html(
		`
          <p class="font-comic text-3xl leading-none"> </p>
          <p class="mt-1 text-sm font-bold"> </p>
        `,
		1
	),
	App[$.FILENAME],
	[[148, 10], [149, 10]]
);

var root_7 = $.add_locations(
	$.from_html(
		`
        <!>
      `,
		1
	),
	App[$.FILENAME],
	[]
);

var root_8 = $.add_locations(
	$.from_html(
		`
        <p class="w-full text-center font-comic text-4xl tracking-wide text-white/80 [text-shadow:2px_2px_0_#17150f]">Bientôt…</p>
      `,
		1
	),
	App[$.FILENAME],
	[[152, 8]]
);

var root_9 = $.add_locations(
	$.from_html(
		`
    
    <div class="absolute flex items-center justify-center gap-5 px-6 py-4">
      <!>
    </div>
  `,
		1
	),
	App[$.FILENAME],
	[[145, 4]]
);

var root_10 = $.add_locations($.from_html(`<p> </p>`), App[$.FILENAME], [[166, 85]]);

var root_11 = $.add_locations(
	$.from_html(
		`
        <div class="flex h-full w-full flex-col justify-between">
          <div class="mt-[22%] mr-[24%] w-[52%] self-end"><!></div>
          <!>
        </div>
      `,
		1
	),
	App[$.FILENAME],
	[[164, 8, [[165, 10]]]]
);

var root_12 = $.add_locations($.from_html(`<p> </p>`), App[$.FILENAME], [[170, 83]]);

var root_13 = $.add_locations(
	$.from_html(
		`
        <div class="flex h-full w-full flex-col">
          <!>
          <div class="mt-[25%] mr-[5%] w-[50%] self-end"><!></div>
        </div>
      `,
		1
	),
	App[$.FILENAME],
	[[169, 8, [[171, 10]]]]
);

var root_14 = $.add_locations(
	$.from_html(
		`
    <div class="absolute flex items-start justify-center">
      <!>
    </div>
  `,
		1
	),
	App[$.FILENAME],
	[[162, 4]]
);

var root_15 = $.add_locations(
	$.from_html(
		`
        <span class="border-[3px] border-ink bg-white px-3 py-1 font-comic text-base tracking-wide shadow-[3px_3px_0_#17150f]"> </span>
      `,
		1
	),
	App[$.FILENAME],
	[[186, 8]]
);

var root_16 = $.add_locations(
	$.from_html(
		`
      <p>Première édition au profit de l'association : les bénéfices du Golden Day #1 lui ont été reversés. D'autres associations pourront être soutenues au fil des éditions.</p>
    `,
		1
	),
	App[$.FILENAME],
	[[199, 6]]
);

var root_17 = $.add_locations(
	$.from_html(
		`
      <p>Dossier de presse, visuels et logo sur demande.</p>
      <a href="mailto:goldenretrieverday@gmail.com?subject=Presse%20Golden%20Days" class="mt-3 inline-block rounded-full border-[3px] border-ink bg-gold px-5 py-1.5 font-comic text-xl tracking-wide shadow-[3px_3px_0_#17150f]">Demander le dossier</a>
    `,
		1
	),
	App[$.FILENAME],
	[[212, 6], [213, 6]]
);

var root_18 = $.add_locations($.from_html(`<li> </li>`), App[$.FILENAME], [[216, 28]]);

var root_19 = $.add_locations(
	$.from_html(
		`
      <ul></ul>
    `,
		1
	),
	App[$.FILENAME],
	[[216, 6]]
);

var root_20 = $.add_locations(
	$.from_html(
		`
    <div class="absolute flex items-center justify-center">
      <div class="w-full"><!></div>
    </div>
  `,
		1
	),
	App[$.FILENAME],
	[[220, 4, [[221, 6]]]]
);

var root_21 = $.add_locations($.from_html(`<li> </li>`), App[$.FILENAME], [[260, 68]]);

var root_22 = $.add_locations(
	$.from_html(
		`
          <h3 class="mt-5 font-comic text-2xl tracking-wide text-cobalt"> </h3>
          <ul class="mt-1 space-y-0.5 font-bold"></ul>
        `,
		1
	),
	App[$.FILENAME],
	[[259, 10], [260, 10]]
);

var root_23 = $.add_locations(
	$.from_html(
		`
        <!>
      `,
		1
	),
	App[$.FILENAME],
	[]
);

var root_24 = $.add_locations($.from_html(`<p class="mt-5 inline-block -rotate-1 border-[3px] border-ink bg-white px-4 py-2 font-comic text-xl tracking-wide shadow-[4px_4px_0_#17150f]"> </p>`), App[$.FILENAME], [[263, 21]]);

var root_25 = $.add_locations(
	$.from_html(
		`
        <div class="mt-6 flex flex-wrap items-center gap-4">
          <a class="rounded-full border-[3px] border-ink bg-gold px-6 py-2 font-comic text-2xl tracking-wide shadow-[3px_3px_0_#17150f]">Réserver</a>
          <span class="font-bold">goldenretrieverday@gmail.com · +32 476 30 26 89</span>
        </div>
      `,
		1
	),
	App[$.FILENAME],
	[[265, 8, [[266, 10], [267, 10]]]]
);

var root_26 = $.add_locations(
	$.from_html(
		`
  
  <div class="fixed inset-0 z-[60] grid place-items-center bg-ink/70 p-6" role="presentation">
    <article class="relative max-h-[90vh] w-full max-w-3xl overflow-y-auto border-[4px] border-ink bg-paper p-8 shadow-[10px_10px_0_#17150f]" role="dialog">
      <button class="absolute top-3 right-3 grid h-10 w-10 place-items-center rounded-full border-[3px] border-ink bg-white font-comic text-2xl shadow-[2px_2px_0_#17150f]" aria-label="Fermer">×</button>
      <span> </span>
      <h2 class="mt-3 font-comic text-6xl leading-none text-orange [text-shadow:3px_3px_0_#17150f]"> </h2>
      <p class="mt-2 text-xl font-black"> <!></p>
      <p class="text-lg font-bold text-cobalt"> </p>
      <p class="mt-4 font-bold"> </p>
      <!>
      <!>
      <!>
    </article>
  </div>
`,
		1
	),
	App[$.FILENAME],
	[
		[
			249,
			2,
			[
				[
					250,
					4,
					[[251, 6], [252, 6], [253, 6], [254, 6], [255, 6], [256, 6]]
				]
			]
		]
	]
);

var root_27 = $.add_locations(
	$.from_html(
		`



<button class="fixed right-3 bottom-3 z-[70] rounded border border-white/40 bg-black/60 px-2 py-1 font-mono text-xs text-white"> </button>

<header class="fixed inset-x-0 top-0 z-50 h-24 bg-gradient-to-b from-black/60 via-black/25 to-transparent">
  <div class="relative mx-auto flex h-full max-w-7xl items-center gap-8 px-6">
    <a href="#accueil" class="mr-auto w-44 shrink-0 translate-y-3 drop-shadow-[0_5px_10px_rgba(0,0,0,.45)] md:w-52"><img alt="Golden Day"/></a>
    <nav class="logo-wrap hidden items-center gap-4 font-comic text-lg tracking-wide text-white [text-shadow:2px_2px_0_#17150f] lg:flex">
      <!>
    </nav>
    <a href="https://www.facebook.com/" target="_blank" rel="noreferrer" aria-label="Facebook" class="grid h-9 w-9 shrink-0 place-items-center rounded-full border-[3px] border-ink bg-sky text-white shadow-[2px_2px_0_#17150f]">
      <svg viewBox="0 0 24 24" class="h-5 w-5 fill-current"><path d="M13.5 22v-8h2.7l.4-3.2h-3.1V8.8c0-.9.3-1.6 1.6-1.6h1.7V4.4c-.3 0-1.3-.1-2.5-.1-2.5 0-4.1 1.5-4.1 4.2v2.3H7.4V14h2.8v8z"></path></svg>
    </a>
  </div>
</header>


<div class="fixed inset-0 -z-10">
  <!>
</div>

<section id="accueil" style="height: 100vh">
  <div class="sticky top-0 h-screen">
  <div class="logo-wrap absolute top-[17vh] left-[11vw] w-[44rem] max-w-[52vw]">
    <h1 class="logo-text font-comic text-[8.5rem] leading-none whitespace-nowrap xl:text-[10.5rem]" data-text="Golden Day"><span>Golden Day</span></h1>
    <p class="inked mt-3 font-comic text-5xl leading-tight text-orange xl:text-6xl">Des chiens, des rencontres, des souvenirs.</p>
    <div class="mt-10 ml-16 w-[42rem] max-w-full"><!></div>
  </div>
  <div class="absolute top-[14vh] right-[7vw] flex flex-col items-center gap-4">
    <p class="font-comic text-3xl tracking-wide text-white [text-shadow:2px_2px_0_#17150f]">Prochain rendez-vous</p>
    <!>
  </div>
  </div>
</section>

<section id="qui-sommes-nous" style="height: calc(100vh * (1 + 0.6))">
  <div class="sticky top-0 h-screen">
  <!>
  </div>
</section>

<section id="evenements" style="height: calc(100vh * (1 + 0.6))">
  <div class="sticky top-0 h-screen">
  <!>
  </div>
</section>

<section id="concepts" style="height: calc(100vh * (1 + 0.6))">
  <div class="sticky top-0 h-screen">
  <!>
  </div>
</section>

<section id="partenaires" style="height: calc(100vh * (1 + 0.6))">
  <div class="sticky top-0 h-screen">
  <div class="absolute flex flex-col items-center justify-center gap-4 text-center">
    <p class="font-comic text-4xl leading-none whitespace-nowrap text-orange [text-shadow:3px_3px_0_#17150f]">Plus qu'une journée avec des chiens.</p>
    <p class="max-w-lg font-comic text-lg leading-tight tracking-wide [text-shadow:1px_1px_0_#fff,-1px_-1px_0_#fff,1px_-1px_0_#fff,-1px_1px_0_#fff]">Les partenaires participent à la vie de l'événement — professionnels du bien-être animal, soins, accessoires, créateurs, restauration, artistes et acteurs locaux.</p>
    <div class="flex max-w-xl flex-wrap justify-center gap-2">
      <!>
    </div>
    <a href="mailto:goldenretrieverday@gmail.com?subject=Partenariat%20Golden%20Days" class="rounded-full border-[3px] border-ink bg-gold px-5 py-1.5 font-comic text-xl tracking-wide shadow-[3px_3px_0_#17150f] transition hover:-translate-y-0.5">Devenir partenaire</a>
  </div>
  </div>
</section>

<section id="associations" style="height: calc(100vh * (1 + 0.6))">
  <div class="sticky top-0 h-screen">
  <div class="absolute flex flex-col justify-center gap-6">
    <h2 class="font-comic text-7xl leading-none text-orange [text-shadow:3px_3px_0_#17150f]">Une dimension solidaire</h2>
    <!>
  </div>
  <div class="absolute flex items-start justify-end">
    <div class="w-full"><!></div>
  </div>
  </div>
</section>

<section id="medias" style="height: calc(100vh * (1 + 0.6))">
  <div class="sticky top-0 h-screen">
  <div class="absolute flex flex-col justify-center gap-6">
    <!>
    <!>
  </div>
  <!>
  </div>
</section>

<section id="contact" style="height: 100vh">
  <div class="sticky top-0 h-screen">
  <div class="absolute flex flex-col justify-center gap-5">
    <div class="-rotate-1 border-[3px] border-ink bg-white px-6 py-5 shadow-[6px_6px_0_#17150f]">
      <p class="font-comic text-lg tracking-wide text-cobalt">Organisation</p>
      <p class="font-comic text-3xl leading-none">Audrey Janssens & Geneviève Richez</p>
      <p class="mt-3 font-bold"><a href="mailto:goldenretrieverday@gmail.com" class="text-cobalt underline decoration-2 underline-offset-2">goldenretrieverday@gmail.com</a></p>
      <p class="font-bold"><a href="tel:+32476302689">+32 476 30 26 89</a></p>
      <div class="mt-4 flex flex-wrap gap-3">
        <a href="mailto:goldenretrieverday@gmail.com" class="rounded-full border-[3px] border-ink bg-gold px-5 py-1.5 font-comic text-xl tracking-wide shadow-[3px_3px_0_#17150f]">Écrire</a>
        <a href="https://www.facebook.com/" target="_blank" rel="noreferrer" class="rounded-full border-[3px] border-ink bg-sky px-5 py-1.5 font-comic text-xl tracking-wide text-white shadow-[3px_3px_0_#17150f]">Facebook</a>
      </div>
    </div>
  </div>
  <div class="absolute flex items-start justify-end">
    <div class="mt-[8%] w-[70%]"><!></div>
  </div>
  </div>
</section>

<!>`,
		1
	),
	App[$.FILENAME],
	[
		[87, 0],
		[
			89,
			0,
			[
				[
					90,
					2,
					[
						[91, 4, [[91, 116]]],
						[92, 4],
						[97, 4, [[98, 6, [[98, 60]]]]]
					]
				]
			]
		],
		[104, 0],
		[
			108,
			0,
			[
				[
					109,
					2,
					[
						[110, 2, [[111, 4, [[111, 123]]], [112, 4], [113, 4]]],
						[117, 2, [[118, 4]]]
					]
				]
			]
		],
		[128, 0, [[129, 2]]],
		[141, 0, [[142, 2]]],
		[159, 0, [[160, 2]]],
		[
			179,
			0,
			[
				[180, 2, [[181, 2, [[182, 4], [183, 4], [184, 4], [189, 4]]]]]
			]
		],

		[
			194,
			0,
			[[195, 2, [[196, 2, [[197, 4]]], [202, 2, [[203, 4]]]]]]
		],
		[208, 0, [[209, 2, [[210, 2]]]]],
		[
			227,
			0,
			[
				[
					228,
					2,
					[
						[
							229,
							2,
							[
								[
									230,
									4,
									[
										[231, 6],
										[232, 6],
										[233, 6, [[233, 32]]],
										[234, 6, [[234, 27]]],
										[235, 6, [[236, 8], [237, 8]]]
									]
								]
							]
						],
						[241, 2, [[242, 4]]]
					]
				]
			]
		]
	]
);

function App($$anchor, $$props) {
	$.check_target(new.target);
	$.push($$props, true, App);

	const nav = [
		["Accueil", "#accueil"],
		["Qui sommes-nous", "#qui-sommes-nous"],
		["Événements", "#evenements"],
		["Concepts", "#concepts"],
		["Partenaires", "#partenaires"],
		["Associations", "#associations"],
		["Médias & infos", "#medias"],
		["Contact", "#contact"]
	];

	let active = $.tag($.state("#accueil"), 'active');

	$.user_effect(() => {
		const io = new IntersectionObserver((es) => es.forEach((e) => e.isIntersecting && $.set(active, `#${e.target.id}`)), { threshold: 0.6 });

		document.querySelectorAll("section").forEach((s) => io.observe(s));

		return () => io.disconnect();
	});

	const events = [
		{
			name: "Golden Friends #1",
			type: "Golden Friends",
			date: "Dimanche 20 septembre 2026",
			place: "Cowor-Cœur, Frameries",
			hours: "13h – 20h",
			blurb: "Un après-midi convivial ouvert à plusieurs types de chiens et à leurs humains : boire un verre, manger, rencontrer d'autres amoureux des chiens, découvrir les partenaires. Nombre de places limité.",
			audience: [
				"Toutes races et chiens croisés",
				"Familles et amis, avec ou sans chien"
			],
			program: [
				"13h — ouverture, bar et restauration",
				"Rencontres, stands et partenaires",
				"20h — fin"
			]
		},

		{
			name: "Golden Day #2",
			type: "Golden Day",
			date: "4 avril 2027",
			place: "Quintessence, Quévy",
			blurb: "Le grand rendez-vous consacré aux Golden Retrievers revient pour une deuxième édition : balade, rencontres, stands et convivialité.",
			program: [
				"Programme, horaires, inscriptions, partenaires et association soutenue à communiquer"
			]
		},

		{
			name: "Golden Friends #2",
			type: "Golden Friends",
			date: "20 juin 2027",
			place: "Havré, près du Bois d'Havré",
			blurb: "Deuxième rendez-vous Golden Friends : une rencontre légère, ouverte à différents chiens, avec un nombre de participants limité.",
			program: [
				"Lieu précis, horaires, balade ou animation, partenaires et réservations à compléter"
			]
		},

		{
			name: "Golden Day #1",
			type: "Golden Day",
			date: "Samedi 5 septembre 2026",
			place: "Mont Panisel & Jardin Suspendu, Mons",
			hours: "10h30 – 18h",
			past: true,
			blurb: "La toute première édition : balade au Mont Panisel puis après-midi au Jardin Suspendu — rencontres, stands, restauration, Poké Dog, animation musicale et solidarité.",
			audience: [
				"Propriétaires de Golden Retrievers",
				"Familles et passionnés de la race",
				"Amoureux des chiens, avec ou sans chien"
			],
			program: [
				"10h30 — accueil des participants",
				"Fin de matinée — balade encadrée au Mont Panisel",
				"Midi — arrivée au Jardin Suspendu",
				"Après-midi — rencontres, partenaires, stands, conseils, food truck et Poké Dog",
				"Animation musicale avec Les Crooners",
				"18h — fin de la journée"
			],
			rules: [
				"Chaque participant reste responsable de son chien",
				"Interactions entre chiens surveillées, laisse ou longe à portée",
				"Respect des participants, des chiens et des lieux",
				"On ramasse — seaux « Golden Crottes » sur place"
			],
			partners: [
				"Comportement canin et bien-être animal",
				"Toilettage et soins",
				"Créateurs et accessoires canins",
				"Food truck, petite restauration et Poké Dog",
				"Les Crooners"
			],
			charity: "Bénéfices reversés à L'Étoile de Bonté"
		}
	];

	const next = events[0];
	let open = $.tag($.state(null), 'open');
	let bare = $.tag($.state(false), 'bare');

	const clips = [
		"/clips/1-2.mp4",
		"/clips/2-3.mp4",
		"/clips/3-4.mp4",
		"/clips/4-5.mp4",
		"/clips/5-6.mp4",
		"/clips/6-7.mp4",
		"/clips/7-8.mp4"
	];

	const HOLD = 0.6;
	let page = $.tag($.state(0), 'page');
	let settled = $.tag($.state(true), 'settled');

	function scrub(node) {
		const videos = [...node.querySelectorAll("video")];
		let raf = 0, cur = 0, target = 0;

		const seek = () => {
			raf = 0;

			const v = videos[cur];

			if (v.readyState >= 1 && !v.seeking) v.currentTime = target;
		};

		const tick = () => {
			const u = scrollY / innerHeight,
				k = u < 1
					? 0
					: Math.min(clips.length - 1, 1 + Math.floor((u - 1) / (1 + HOLD))),
				r = u - ($.strict_equals(k, 0) ? 0 : 1 + (k - 1) * (1 + HOLD));

			const t = Math.min(1, Math.max(0, r - ($.strict_equals(k, 0) ? 0 : HOLD)));

			cur = k;

			const f = k + t;

			videos.forEach((v, i) => v.style.opacity = $.strict_equals(i, cur) ? "1" : "0");

			const v = videos[cur];

			target = t * (v.duration - 0.05 || 0);
			$.set(page, t > 0.5 ? cur + 1 : cur, true);
			$.set(settled, t <= 0.005 || t >= 0.995, true);
			raf ||= requestAnimationFrame(seek);
		};

		tick();
		addEventListener("scroll", tick, { passive: true });

		videos.forEach((v) => {
			v.addEventListener("loadedmetadata", tick);

			v.addEventListener("seeked", () => {
				if (Math.abs(v.currentTime - target) > 0.02 && $.strict_equals(v, videos[cur])) raf ||= requestAnimationFrame(seek);
			});
		});

		return () => removeEventListener("scroll", tick);
	}

	const IMG = 2752 / 1536;
	let vw = $.tag($.state(1), 'vw');
	let vh = $.tag($.state(1), 'vh');

	const at = (x, y, w, h) => {
		const wide = $.get(vw) / $.get(vh) > IMG;

		const W = wide ? $.get(vw) : $.get(vh) * IMG,
			H = wide ? $.get(vw) / IMG : $.get(vh);

		const ox = ($.get(vw) - W) / 2,
			oy = ($.get(vh) - H) / 2;

		return `left:${ox + x / 100 * W}px;top:${oy + y / 100 * H}px;width:${w / 100 * W}px;height:${h / 100 * H}px`;
	};

	const whoCases = [
		{
			box: [6, 54, 28, 32],
			big: 0.75,
			seed: 3,
			name: "Geneviève",
			text: "Geneviève Richez, co-créatrice de Golden Days. Passionnée de Golden Retrievers, elle voulait un rendez-vous qu'elle ne trouvait pas assez près de chez elle."
		},

		{
			box: [37, 52, 26, 32],
			big: 0.78,
			seed: 5,
			name: "Audrey",
			text: "Audrey Janssens, co-créatrice de Golden Days. Une amitié, une passion commune, et l'envie d'une journée joyeuse, accessible et bien organisée."
		},

		{
			box: [69, 13, 26, 27],
			big: 0.3,
			seed: 8,
			name: "Oxy",
			text: "Un Golden plein de malice : une montée discrète sur le divan, les poules surveillées d'un peu trop près, et la première flaque d'eau venue."
		},

		{
			box: [69, 57, 26, 27],
			big: 0.82,
			seed: 2,
			name: "Enzo",
			text: "De grandes batailles contre son doudou dinosaure — et, derrière cette vie mouvementée, un Golden étonnamment propre et presque élégant."
		}
	];

	const concepts = [
		{
			name: "Golden Day",
			box: [6, 12, 41, 80],
			seed: 21,
			intro: "Le rendez-vous entièrement consacré aux Golden Retrievers — propriétaires, familles, passionnés, et ceux qui aiment simplement les Goldens, même sans chien.",
			items: [
				"Une balade avec les chiens",
				"Rencontres entre propriétaires et passionnés",
				"Partenaires, stands et créateurs",
				"Restauration, animations, tombola",
				"Musique ou concerts",
				"Une dimension solidaire"
			],
			note: "Ni exposition canine, ni compétition : une journée ensemble."
		},

		{
			name: "Golden Friends",
			box: [54, 10, 44, 72],
			seed: 34,
			intro: "L'esprit Golden Day dans une formule plus simple, ouverte à d'autres chiens — races, croisés, amis et familles.",
			items: [
				"Un nombre de chiens limité",
				"Un lieu convivial, à taille humaine",
				"À boire, à manger, des rencontres",
				"Quelques stands ou partenaires",
				"Balade ou animation selon l'édition"
			],
			note: "Chiens, convivialité, rencontres et bonne humeur."
		}
	];

	const partners = [
		"Bien-être animal",
		"Comportement canin",
		"Toilettage & soins",
		"Accessoires",
		"Créateurs",
		"Restauration",
		"Poké Dog",
		"Musique",
		"Acteurs locaux"
	];

	const rules = [
		"Chaque participant reste responsable de son chien",
		"Interactions entre chiens surveillées",
		"Laisse ou longe à portée de main",
		"Respect des participants, des chiens et des lieux",
		"On ramasse — seaux « Golden Crottes » sur place"
	];

	const eventCases = [
		[11, 19, 21, 26],
		[36, 19, 27, 28],
		[67, 18, 25, 28],
		[7, 54, 25, 28],
		[37, 55, 26, 27],
		[67, 54, 25, 28]
	];

	var $$exports = { ...$.legacy_api() };

	$.next();

	var fragment = root_27();
	var button = $.sibling($.first_child(fragment));
	var text = $.only_child(button, true);
	var header = $.sibling(button, 2);
	var div = $.sibling($.child(header));
	var a = $.sibling($.child(div));
	var img = $.only_child(a);
	var nav_1 = $.sibling(a, 2);
	var node_1 = $.sibling($.child(nav_1));

	$.add_svelte_meta(
		() => $.each(node_1, 17, () => nav, $.index, ($$anchor, $$item) => {
			var $$array = $.derived(() => $.to_array($.get($$item), 2));
			let label = () => $.get($$array)[0];

			label();

			let href = () => $.get($$array)[1];

			href();
			$.next();

			var fragment_1 = root_1();
			var a_1 = $.sibling($.first_child(fragment_1));
			var node_2 = $.child(a_1);

			{
				var consequent = ($$anchor) => {
					var span = root();
					var text_1 = $.only_child(span, true);

					$.template_effect(() => $.set_text(text_1, label()));
					$.append($$anchor, span);
				};

				var alternate = ($$anchor) => {
					var text_2 = $.text();

					$.template_effect(() => $.set_text(text_2, label()));
					$.append($$anchor, text_2);
				};

				$.add_svelte_meta(
					() => $.if(node_2, ($$render) => {
						if ($.strict_equals($.get(active), href())) $$render(consequent); else $$render(alternate, -1);
					}),
					'if',
					App,
					94,
					157
				);
			}

			$.reset(a_1);
			$.next();

			$.template_effect(() => {
				$.set_attribute(a_1, 'href', href());
				$.set_class(a_1, 1, `whitespace-nowrap transition-all duration-300 hover:text-gold ${$.strict_equals($.get(active), href()) ? 'logo-text text-[3.5rem]' : ''}`);
				$.set_attribute(a_1, 'data-text', label());
			});

			$.append($$anchor, fragment_1);
		}),
		'each',
		App,
		93,
		6
	);

	$.next();
	$.reset(nav_1);
	$.next(3);
	$.reset(div);
	$.next();
	$.reset(header);

	var div_1 = $.sibling(header, 2);
	var node_3 = $.sibling($.child(div_1));

	$.add_svelte_meta(
		() => $.each(node_3, 17, () => clips, $.index, ($$anchor, src) => {
			var video = root_2();

			video.muted = true;
			$.template_effect(() => $.set_attribute(video, 'src', $.get(src)));
			$.append($$anchor, video);
		}),
		'each',
		App,
		105,
		2
	);

	$.next();
	$.reset(div_1);
	$.action(div_1, ($$node) => scrub?.($$node));

	var section = $.sibling(div_1, 2);
	var div_2 = $.sibling($.child(section));
	var div_3 = $.sibling($.child(div_2));
	var div_4 = $.sibling($.child(div_3), 5);
	var node_4 = $.child(div_4);

	$.add_svelte_meta(
		() => Bubble(node_4, {
			big: 0.96,
			class: 'text-center text-3xl',
			children: $.wrap_snippet(App, ($$anchor, $$slotProps) => {
				$.next();

				var text_3 = $.text('\n      Une série de rendez-vous pour réunir les amoureux des chiens autour de moments simples : marcher ensemble, partager un verre, découvrir des partenaires, rire, profiter de son chien et rencontrer d\'autres passionnés.\n    ');

				$.append($$anchor, text_3);
			}),
			$$slots: { default: true }
		}),
		'component',
		App,
		113,
		50,
		{ componentTag: 'Bubble' }
	);

	$.reset(div_4);
	$.next();
	$.reset(div_3);

	var div_5 = $.sibling(div_3, 2);
	var node_5 = $.sibling($.child(div_5), 3);

	$.add_svelte_meta(
		() => Calendar(node_5, {
			get date() {
				return next.date;
			},

			get type() {
				return next.type;
			},
			tilt: 2,
			onclick: () => $.set(open, next, true),
			children: $.wrap_snippet(App, ($$anchor, $$slotProps) => {
				$.next();

				var fragment_3 = root_3();
				var p_1 = $.sibling($.first_child(fragment_3));
				var text_4 = $.only_child(p_1, true);
				var p_2 = $.sibling(p_1, 2);
				var text_5 = $.child(p_2, true);
				var text_6 = $.sibling(text_5, 2, true);

				$.reset(p_2);
				$.next(3);

				$.template_effect(() => {
					$.set_text(text_4, next.name);
					$.set_text(text_5, next.place);
					$.set_text(text_6, next.hours);
				});

				$.append($$anchor, fragment_3);
			}),
			$$slots: { default: true }
		}),
		'component',
		App,
		119,
		4,
		{ componentTag: 'Calendar' }
	);

	$.next();
	$.reset(div_5);
	$.next();
	$.reset(div_2);
	$.next();
	$.reset(section);

	var section_1 = $.sibling(section, 2);
	var div_6 = $.sibling($.child(section_1));
	var node_6 = $.sibling($.child(div_6));

	$.add_svelte_meta(
		() => $.each(node_6, 17, () => whoCases, $.index, ($$anchor, c) => {
			$.next();

			var fragment_4 = root_5();
			var div_7 = $.sibling($.first_child(fragment_4));
			var node_7 = $.sibling($.child(div_7));

			$.add_svelte_meta(
				() => Bubble(node_7, {
					get big() {
						return $.get(c).big;
					},

					get seed() {
						return $.get(c).seed;
					},
					class: 'w-full text-center text-2xl',
					children: $.wrap_snippet(App, ($$anchor, $$slotProps) => {
						$.next();

						var fragment_5 = root_4();
						var p_3 = $.sibling($.first_child(fragment_5));
						var text_7 = $.only_child(p_3, true);
						var p_4 = $.sibling(p_3, 2);
						var text_8 = $.only_child(p_4, true);

						$.next();

						$.template_effect(() => {
							$.set_text(text_7, $.get(c).name);
							$.set_text(text_8, $.get(c).text);
						});

						$.append($$anchor, fragment_5);
					}),
					$$slots: { default: true }
				}),
				'component',
				App,
				132,
				6,
				{ componentTag: 'Bubble' }
			);

			$.next();
			$.reset(div_7);
			$.next();
			$.template_effect(($0) => $.set_style(div_7, $0), [() => at(...$.get(c).box)]);
			$.append($$anchor, fragment_4);
		}),
		'each',
		App,
		130,
		2
	);

	$.next();
	$.reset(div_6);
	$.next();
	$.reset(section_1);

	var section_2 = $.sibling(section_1, 2);
	var div_8 = $.sibling($.child(section_2));
	var node_8 = $.sibling($.child(div_8));

	$.add_svelte_meta(
		() => $.each(node_8, 17, () => eventCases, $.index, ($$anchor, box, i) => {
			const e = $.tag($.derived(() => events[i]), 'e');

			$.get(e);
			$.next();

			var fragment_6 = root_9();
			var div_9 = $.sibling($.first_child(fragment_6));
			var node_9 = $.sibling($.child(div_9));

			{
				var consequent_1 = ($$anchor) => {
					var fragment_7 = root_7();
					var node_10 = $.sibling($.first_child(fragment_7));

					$.add_svelte_meta(
						() => Calendar(node_10, {
							get date() {
								return $.get(e).date;
							},

							get type() {
								return $.get(e).type;
							},

							get past() {
								return $.get(e).past;
							},
							tilt: i % 2 ? 1.5 : -1.5,
							onclick: () => $.set(open, $.get(e), true),
							children: $.wrap_snippet(App, ($$anchor, $$slotProps) => {
								$.next();

								var fragment_8 = root_6();
								var p_5 = $.sibling($.first_child(fragment_8));
								var text_9 = $.only_child(p_5, true);
								var p_6 = $.sibling(p_5, 2);
								var text_10 = $.only_child(p_6, true);

								$.next();

								$.template_effect(() => {
									$.set_text(text_9, $.get(e).name);
									$.set_text(text_10, $.get(e).place);
								});

								$.append($$anchor, fragment_8);
							}),
							$$slots: { default: true }
						}),
						'component',
						App,
						147,
						8,
						{ componentTag: 'Calendar' }
					);

					$.next();
					$.append($$anchor, fragment_7);
				};

				var alternate_1 = ($$anchor) => {
					var fragment_9 = root_8();

					$.next(2);
					$.append($$anchor, fragment_9);
				};

				$.add_svelte_meta(
					() => $.if(node_9, ($$render) => {
						if ($.get(e)) $$render(consequent_1); else $$render(alternate_1, -1);
					}),
					'if',
					App,
					146,
					6
				);
			}

			$.next();
			$.reset(div_9);
			$.next();
			$.template_effect(($0) => $.set_style(div_9, $0), [() => at(...$.get(box))]);
			$.append($$anchor, fragment_6);
		}),
		'each',
		App,
		143,
		2
	);

	$.next();
	$.reset(div_8);
	$.next();
	$.reset(section_2);

	var section_3 = $.sibling(section_2, 2);
	var div_10 = $.sibling($.child(section_3));
	var node_11 = $.sibling($.child(div_10));

	$.add_svelte_meta(
		() => $.each(node_11, 17, () => concepts, $.index, ($$anchor, c) => {
			$.next();

			var fragment_10 = root_14();
			var div_11 = $.sibling($.first_child(fragment_10));
			var node_12 = $.sibling($.child(div_11));

			{
				var consequent_2 = ($$anchor) => {
					var fragment_11 = root_11();
					var div_12 = $.sibling($.first_child(fragment_11));
					var div_13 = $.sibling($.child(div_12));
					var node_13 = $.child(div_13);

					$.add_svelte_meta(
						() => Bubble(node_13, {
							get seed() {
								return $.get(c).seed;
							},
							big: 0.37,
							class: 'text-center text-2xl',
							children: $.wrap_snippet(App, ($$anchor, $$slotProps) => {
								$.next();

								var text_11 = $.text();

								$.template_effect(() => $.set_text(text_11, $.get(c).note));
								$.append($$anchor, text_11);
							}),
							$$slots: { default: true }
						}),
						'component',
						App,
						165,
						58,
						{ componentTag: 'Bubble' }
					);

					$.reset(div_13);

					var node_14 = $.sibling(div_13, 2);

					$.add_svelte_meta(
						() => Caption(node_14, {
							get title() {
								return $.get(c).name;
							},
							class: 'mb-[5%] ml-[1%] w-full max-w-xl self-start',
							children: $.wrap_snippet(App, ($$anchor, $$slotProps) => {
								var p_7 = root_10();
								var text_12 = $.only_child(p_7, true);

								$.template_effect(() => $.set_text(text_12, $.get(c).intro));
								$.append($$anchor, p_7);
							}),
							$$slots: { default: true }
						}),
						'component',
						App,
						166,
						10,
						{ componentTag: 'Caption' }
					);

					$.next();
					$.reset(div_12);
					$.next();
					$.append($$anchor, fragment_11);
				};

				var alternate_2 = ($$anchor) => {
					var fragment_13 = root_13();
					var div_14 = $.sibling($.first_child(fragment_13));
					var node_15 = $.sibling($.child(div_14));

					$.add_svelte_meta(
						() => Caption(node_15, {
							get title() {
								return $.get(c).name;
							},
							class: 'mt-[5%] mr-[8%] w-full max-w-xl self-end',
							children: $.wrap_snippet(App, ($$anchor, $$slotProps) => {
								var p_8 = root_12();
								var text_13 = $.only_child(p_8, true);

								$.template_effect(() => $.set_text(text_13, $.get(c).intro));
								$.append($$anchor, p_8);
							}),
							$$slots: { default: true }
						}),
						'component',
						App,
						170,
						10,
						{ componentTag: 'Caption' }
					);

					var div_15 = $.sibling(node_15, 2);
					var node_16 = $.child(div_15);

					$.add_svelte_meta(
						() => Bubble(node_16, {
							get seed() {
								return $.get(c).seed;
							},
							big: 0.64,
							class: 'text-center text-2xl',
							children: $.wrap_snippet(App, ($$anchor, $$slotProps) => {
								$.next();

								var text_14 = $.text();

								$.template_effect(() => $.set_text(text_14, $.get(c).note));
								$.append($$anchor, text_14);
							}),
							$$slots: { default: true }
						}),
						'component',
						App,
						171,
						57,
						{ componentTag: 'Bubble' }
					);

					$.reset(div_15);
					$.next();
					$.reset(div_14);
					$.next();
					$.append($$anchor, fragment_13);
				};

				$.add_svelte_meta(
					() => $.if(node_12, ($$render) => {
						if ($.strict_equals($.get(c).name, "Golden Day")) $$render(consequent_2); else $$render(alternate_2, -1);
					}),
					'if',
					App,
					163,
					6
				);
			}

			$.next();
			$.reset(div_11);
			$.next();
			$.template_effect(($0) => $.set_style(div_11, $0), [() => at(...$.get(c).box)]);
			$.append($$anchor, fragment_10);
		}),
		'each',
		App,
		161,
		2
	);

	$.next();
	$.reset(div_10);
	$.next();
	$.reset(section_3);

	var section_4 = $.sibling(section_3, 2);
	var div_16 = $.sibling($.child(section_4));
	var div_17 = $.sibling($.child(div_16));
	var div_18 = $.sibling($.child(div_17), 5);
	var node_17 = $.sibling($.child(div_18));

	$.add_svelte_meta(
		() => $.each(node_17, 17, () => partners, $.index, ($$anchor, p, i) => {
			$.next();

			var fragment_15 = root_15();
			var span_1 = $.sibling($.first_child(fragment_15));

			$.set_style(span_1, `transform: rotate(${i * 7 % 5 - 2}deg)`);

			var text_15 = $.only_child(span_1, true);

			$.next();
			$.template_effect(() => $.set_text(text_15, $.get(p)));
			$.append($$anchor, fragment_15);
		}),
		'each',
		App,
		185,
		6
	);

	$.next();
	$.reset(div_18);
	$.next(3);
	$.reset(div_17);
	$.next();
	$.reset(div_16);
	$.next();
	$.reset(section_4);

	var section_5 = $.sibling(section_4, 2);
	var div_19 = $.sibling($.child(section_5));
	var div_20 = $.sibling($.child(div_19));
	var node_18 = $.sibling($.child(div_20), 3);

	$.add_svelte_meta(
		() => Caption(node_18, {
			title: 'L\'Étoile de Bonté',
			children: $.wrap_snippet(App, ($$anchor, $$slotProps) => {
				$.next();

				var fragment_16 = root_16();

				$.next(2);
				$.append($$anchor, fragment_16);
			}),
			$$slots: { default: true }
		}),
		'component',
		App,
		198,
		4,
		{ componentTag: 'Caption' }
	);

	$.next();
	$.reset(div_20);

	var div_21 = $.sibling(div_20, 2);
	var div_22 = $.sibling($.child(div_21));
	var node_19 = $.child(div_22);

	$.add_svelte_meta(
		() => Bubble(node_19, {
			seed: 11,
			big: 0.28,
			class: 'text-center text-2xl',
			children: $.wrap_snippet(App, ($$anchor, $$slotProps) => {
				$.next();

				var text_16 = $.text('Golden Days associe ses événements au soutien concret de la protection animale : célébrer les chiens tout en aidant ceux qui agissent pour leur bien-être.');

				$.append($$anchor, text_16);
			}),
			$$slots: { default: true }
		}),
		'component',
		App,
		203,
		24,
		{ componentTag: 'Bubble' }
	);

	$.reset(div_22);
	$.next();
	$.reset(div_21);
	$.next();
	$.reset(div_19);
	$.next();
	$.reset(section_5);

	var section_6 = $.sibling(section_5, 2);
	var div_23 = $.sibling($.child(section_6));
	var div_24 = $.sibling($.child(div_23));
	var node_20 = $.sibling($.child(div_24));

	$.add_svelte_meta(
		() => Caption(node_20, {
			title: 'Espace presse',
			children: $.wrap_snippet(App, ($$anchor, $$slotProps) => {
				$.next();

				var fragment_17 = root_17();

				$.next(4);
				$.append($$anchor, fragment_17);
			}),
			$$slots: { default: true }
		}),
		'component',
		App,
		211,
		4,
		{ componentTag: 'Caption' }
	);

	var node_21 = $.sibling(node_20, 2);

	$.add_svelte_meta(
		() => Caption(node_21, {
			title: 'Infos pratiques',
			children: $.wrap_snippet(App, ($$anchor, $$slotProps) => {
				$.next();

				var fragment_18 = root_19();
				var ul = $.sibling($.first_child(fragment_18));

				$.add_svelte_meta(
					() => $.each(ul, 21, () => rules, $.index, ($$anchor, r) => {
						var li = root_18();
						var text_17 = $.only_child(li);

						$.template_effect(() => $.set_text(text_17, `★ ${$.get(r) ?? ''}`));
						$.append($$anchor, li);
					}),
					'each',
					App,
					216,
					10
				);

				$.reset(ul);
				$.next();
				$.append($$anchor, fragment_18);
			}),
			$$slots: { default: true }
		}),
		'component',
		App,
		215,
		4,
		{ componentTag: 'Caption' }
	);

	$.next();
	$.reset(div_24);

	var node_22 = $.sibling(div_24, 2);

	$.add_svelte_meta(
		() => $.each(
			node_22,
			16,
			() => [
				["Wouf !", 70, 31, 10, -3, 0.37, 130],
				["Wouf !", 85, 40, 10, -4, 0.55, 84],
				["Clic clac !", 62, 74, 12, 4, 0.62, 140]
			],
			$.index,
			($$anchor, $$item) => {
				var $$array_1 = $.derived(() => $.to_array($$item, 7));
				let txt = () => $.get($$array_1)[0];

				txt();

				let x = () => $.get($$array_1)[1];

				x();

				let y = () => $.get($$array_1)[2];

				y();

				let w = () => $.get($$array_1)[3];

				w();

				let tilt = () => $.get($$array_1)[4];

				tilt();

				let big = () => $.get($$array_1)[5];

				big();

				let seed = () => $.get($$array_1)[6];

				seed();
				$.next();

				var fragment_19 = root_20();
				var div_25 = $.sibling($.first_child(fragment_19));
				var div_26 = $.sibling($.child(div_25));
				var node_23 = $.child(div_26);

				$.add_svelte_meta(
					() => Bubble(node_23, {
						get seed() {
							return seed();
						},

						get big() {
							return big();
						},
						class: 'text-center text-xl',
						children: $.wrap_snippet(App, ($$anchor, $$slotProps) => {
							$.next();

							var text_18 = $.text();

							$.template_effect(() => $.set_text(text_18, txt()));
							$.append($$anchor, text_18);
						}),
						$$slots: { default: true }
					}),
					'component',
					App,
					221,
					63,
					{ componentTag: 'Bubble' }
				);

				$.reset(div_26);
				$.next();
				$.reset(div_25);
				$.next();

				$.template_effect(
					($0) => {
						$.set_style(div_25, $0);
						$.set_style(div_26, `transform: rotate(${tilt() ?? ''}deg)`);
					},
					[() => at(x(), y(), w(), 10)]
				);

				$.append($$anchor, fragment_19);
			}
		),
		'each',
		App,
		219,
		2
	);

	$.next();
	$.reset(div_23);
	$.next();
	$.reset(section_6);

	var section_7 = $.sibling(section_6, 2);
	var div_27 = $.sibling($.child(section_7));
	var div_28 = $.sibling($.child(div_27));
	var div_29 = $.sibling(div_28, 2);
	var div_30 = $.sibling($.child(div_29));
	var node_24 = $.child(div_30);

	$.add_svelte_meta(
		() => Bubble(node_24, {
			seed: 17,
			big: 0.37,
			class: 'text-center text-2xl',
			children: $.wrap_snippet(App, ($$anchor, $$slotProps) => {
				$.next();

				var text_19 = $.text('À très vite pour de nouveaux moments Golden !');

				$.append($$anchor, text_19);
			}),
			$$slots: { default: true }
		}),
		'component',
		App,
		242,
		33,
		{ componentTag: 'Bubble' }
	);

	$.reset(div_30);
	$.next();
	$.reset(div_29);
	$.next();
	$.reset(div_27);
	$.next();
	$.reset(section_7);

	var node_25 = $.sibling(section_7, 2);

	{
		var consequent_7 = ($$anchor) => {
			const e = $.tag($.derived(() => $.get(open)), 'e');

			$.get(e);

			var fragment_21 = root_26();
			var div_31 = $.sibling($.first_child(fragment_21));
			var article = $.sibling($.child(div_31));
			var button_1 = $.sibling($.child(article));
			var span_2 = $.sibling(button_1, 2);
			var text_20 = $.only_child(span_2, true);
			var h2 = $.sibling(span_2, 2);
			var text_21 = $.only_child(h2, true);
			var p_9 = $.sibling(h2, 2);
			var text_22 = $.child(p_9, true);
			var node_26 = $.sibling(text_22);

			{
				var consequent_3 = ($$anchor) => {
					var text_23 = $.text();

					$.template_effect(() => $.set_text(text_23, ` · ${$.get(e).hours ?? ''}`));
					$.append($$anchor, text_23);
				};

				$.add_svelte_meta(
					() => $.if(node_26, ($$render) => {
						if ($.get(e).hours) $$render(consequent_3);
					}),
					'if',
					App,
					254,
					49
				);
			}

			$.reset(p_9);

			var p_10 = $.sibling(p_9, 2);
			var text_24 = $.only_child(p_10, true);
			var p_11 = $.sibling(p_10, 2);
			var text_25 = $.only_child(p_11, true);
			var node_27 = $.sibling(p_11, 2);

			$.add_svelte_meta(
				() => $.each(
					node_27,
					17,
					() => [
						["Pour qui ?", $.get(e).audience],
						["Programme", $.get(e).program],
						["Les règles essentielles", $.get(e).rules],
						["Partenaires & animations", $.get(e).partners]
					],
					$.index,
					($$anchor, $$item) => {
						var $$array_2 = $.derived(() => $.to_array($.get($$item), 2));
						let title = () => $.get($$array_2)[0];

						title();

						let items = () => $.get($$array_2)[1];

						items();
						$.next();

						var fragment_23 = root_23();
						var node_28 = $.sibling($.first_child(fragment_23));

						{
							var consequent_4 = ($$anchor) => {
								var fragment_24 = root_22();
								var h3 = $.sibling($.first_child(fragment_24));
								var text_26 = $.only_child(h3, true);
								var ul_1 = $.sibling(h3, 2);

								$.add_svelte_meta(
									() => $.each(ul_1, 21, items, $.index, ($$anchor, it) => {
										var li_1 = root_21();
										var text_27 = $.only_child(li_1);

										$.template_effect(() => $.set_text(text_27, `★ ${$.get(it) ?? ''}`));
										$.append($$anchor, li_1);
									}),
									'each',
									App,
									260,
									49
								);

								$.reset(ul_1);
								$.next();
								$.template_effect(() => $.set_text(text_26, title()));
								$.append($$anchor, fragment_24);
							};

							$.add_svelte_meta(
								() => $.if(node_28, ($$render) => {
									if (items()) $$render(consequent_4);
								}),
								'if',
								App,
								258,
								8
							);
						}

						$.next();
						$.append($$anchor, fragment_23);
					}
				),
				'each',
				App,
				257,
				6
			);

			var node_29 = $.sibling(node_27, 2);

			{
				var consequent_5 = ($$anchor) => {
					var p_12 = root_24();
					var text_28 = $.only_child(p_12);

					$.template_effect(() => $.set_text(text_28, `♥ ${$.get(e).charity ?? ''}`));
					$.append($$anchor, p_12);
				};

				$.add_svelte_meta(
					() => $.if(node_29, ($$render) => {
						if ($.get(e).charity) $$render(consequent_5);
					}),
					'if',
					App,
					263,
					6
				);
			}

			var node_30 = $.sibling(node_29, 2);

			{
				var consequent_6 = ($$anchor) => {
					var fragment_25 = root_25();
					var div_32 = $.sibling($.first_child(fragment_25));
					var a_2 = $.sibling($.child(div_32));

					$.next(3);
					$.reset(div_32);
					$.next();
					$.template_effect(($0) => $.set_attribute(a_2, 'href', `mailto:goldenretrieverday@gmail.com?subject=${$0 ?? ''}`), [() => encodeURIComponent(`Réservation — ${$.get(e).name}`)]);
					$.append($$anchor, fragment_25);
				};

				$.add_svelte_meta(
					() => $.if(node_30, ($$render) => {
						if (!$.get(e).past) $$render(consequent_6);
					}),
					'if',
					App,
					264,
					6
				);
			}

			$.next();
			$.reset(article);
			$.next();
			$.reset(div_31);
			$.next();

			$.template_effect(() => {
				$.set_class(span_2, 1, `rounded-full border-[3px] border-ink px-3 py-0.5 font-comic tracking-wide ${$.strict_equals($.get(e).type, 'Golden Day') ? 'bg-gold' : 'bg-white'}`);
				$.set_text(text_20, $.get(e).type);
				$.set_text(text_21, $.get(e).name);
				$.set_text(text_22, $.get(e).date);
				$.set_text(text_24, $.get(e).place);
				$.set_text(text_25, $.get(e).blurb);
			});

			$.delegated('click', div_31, function click_1() {
				return $.set(open, null);
			});

			$.delegated('click', article, function click_2(ev) {
				return ev.stopPropagation();
			});

			$.delegated('click', button_1, function click_3() {
				return $.set(open, null);
			});

			$.append($$anchor, fragment_21);
		};

		$.add_svelte_meta(
			() => $.if(node_25, ($$render) => {
				if ($.get(open)) $$render(consequent_7);
			}),
			'if',
			App,
			247,
			0
		);
	}

	$.template_effect(
		($0, $1, $2, $3, $4, $5) => {
			$.set_text(text, $.get(bare) ? "html" : "bare");
			$.set_attribute(header, 'hidden', $.get(bare));
			$.set_attribute(img, 'src', logo);
			$.set_class(section, 1, `relative ${$.get(bare) ? '[&>*]:invisible' : ''}`);
			$.set_style(div_2, `opacity: ${$.get(settled) && $.strict_equals($.get(page), 0) ? 1 : 0}; transition: opacity .15s`);
			$.set_class(section_1, 1, `relative ${$.get(bare) ? '[&>*]:invisible' : ''}`);
			$.set_style(div_6, `opacity: ${$.get(settled) && $.strict_equals($.get(page), 1) ? 1 : 0}; transition: opacity .15s`);
			$.set_class(section_2, 1, `relative ${$.get(bare) ? '[&>*]:invisible' : ''}`);
			$.set_style(div_8, `opacity: ${$.get(settled) && $.strict_equals($.get(page), 2) ? 1 : 0}; transition: opacity .15s`);
			$.set_class(section_3, 1, `relative ${$.get(bare) ? '[&>*]:invisible' : ''}`);
			$.set_style(div_10, `opacity: ${$.get(settled) && $.strict_equals($.get(page), 3) ? 1 : 0}; transition: opacity .15s`);
			$.set_class(section_4, 1, `relative ${$.get(bare) ? '[&>*]:invisible' : ''}`);
			$.set_style(div_16, `opacity: ${$.get(settled) && $.strict_equals($.get(page), 4) ? 1 : 0}; transition: opacity .15s`);
			$.set_style(div_17, $0);
			$.set_class(section_5, 1, `relative ${$.get(bare) ? '[&>*]:invisible' : ''}`);
			$.set_style(div_19, `opacity: ${$.get(settled) && $.strict_equals($.get(page), 5) ? 1 : 0}; transition: opacity .15s`);
			$.set_style(div_20, $1);
			$.set_style(div_21, $2);
			$.set_class(section_6, 1, `relative ${$.get(bare) ? '[&>*]:invisible' : ''}`);
			$.set_style(div_23, `opacity: ${$.get(settled) && $.strict_equals($.get(page), 6) ? 1 : 0}; transition: opacity .15s`);
			$.set_style(div_24, $3);
			$.set_class(section_7, 1, `relative ${$.get(bare) ? '[&>*]:invisible' : ''}`);
			$.set_style(div_27, `opacity: ${$.get(settled) && $.strict_equals($.get(page), 7) ? 1 : 0}; transition: opacity .15s`);
			$.set_style(div_28, $4);
			$.set_style(div_29, $5);
		},
		[
			() => at(31, 12, 40, 36),
			() => at(6, 15, 25, 72),
			() => at(58, 10, 38, 34),
			() => at(9, 24, 34, 54),
			() => at(8, 25, 24, 62),
			() => at(60, 12, 36, 30)
		]
	);

	$.bind_window_size('innerWidth', function set($$value) {
		$.set(vw, $$value, true);
	});

	$.bind_window_size('innerHeight', function set($$value) {
		$.set(vh, $$value, true);
	});

	$.delegated('click', button, function click() {
		return $.set(bare, !$.get(bare));
	});

	$.append($$anchor, fragment);

	return $.pop($$exports);
}

if (import.meta.hot) {
	App = $.hmr(App);

	import.meta.hot.accept((module) => {
		App[$.HMR].update(module.default);
	});
}

export default App;

$.delegate(['click']);